<template>
  <div
    :id="this.id"
    :data-hide-desktop="!this.internal_config.showDesktop"
    :data-hide-mobile="!this.internal_config.showMobile"
    :config-properties="JSON.stringify(internal_config)"
    class="sitebuilder-element-container big-is-receiver"
    :style="style()"
    element="GroupMenuComponent"
    @contextmenu.prevent="handler($event)"
    @click="focusElement($event)">

    <vue-draggable-resizable
      :w="parseInt(internal_config.width)"
      :h="parseInt(internal_config.height) ? parseInt(internal_config.height) : 60"
      :draggable="false"
      :enable-native-drag="true" @resizing="onResize">

      <options-element-bar
        ref="optionsBar" :elem="this"
        name="ct-component-GroupMenuComponent">
        <img
          v-tooltip="{content:$t('ct-add-menu'), class: 'tooltip-custom'}"
          src="static/images/icons/add.svg"
          class="svg-icon normal-action"
          @click="addMenu">
      </options-element-bar>
      <div
        :style="{
          borderRadius: radius,
          background: background,
          border : border,
          boxShadow: boxShadow,
          paddingTop : paddingTop,
          paddingLeft : paddingLeft,
          paddingRight : paddingRight,
          paddingBottom : paddingBottom,
          gap: `${horizontalMargin}px`,
      }" class="container-menu-group">
        <component
          v-for="(element,index) in elements" :is="element.name" :config="element.config"
          :key="index"
          :id="element.id" :height_start="index" :preview="preview"
          :childs="element.childs"
          @setCallbackChangeDevice="setCallbackChangeDevice"/>
      </div>

      <sync-drag :target="this"/>
    </vue-draggable-resizable>


    <resources ref="resourcesData"/>
  </div>
</template>

<script>

import Data from './Model';
import Resources from './Resources.vue';
import OptionsElementBar from "../../OptionsElementBar";

export default {
  name: 'GroupMenuComponent',
  components: {
    OptionsElementBar,
    Resources
  },
  props: ['config', 'childs', 'device', 'id', 'preview'],
  data() {
    return Data.data();
  },
  computed: {
    paddingTop() {
      return this.internal_config.paddingTopContainer;
    },
    paddingLeft() {
      return this.internal_config.paddingLeftContainer;
    },
    paddingRight() {
      return this.internal_config.paddingRightContainer;
    },
    paddingBottom() {
      return this.internal_config.paddingBottomContainer;
    },
    boxShadow() {
      return this.internal_config.boxShadow;
    },
    border() {
      return this.internal_config.border;
    },
    horizontalMargin() {
      return typeof this.internal_config.horizontalMargin !== 'undefined' ? this.internal_config.horizontalMargin : 0;
    },
    radius() {
      return this.internal_config.borderRadius;
    },
    background() {
      let bg = this.internal_config.backgroundColor;

      if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {

        bg += ' url("' + this.internal_config.backgroundImage + '")';
        bg += ' ' + this.internal_config.backgroundPosition;
        bg += ' / ' + this.internal_config.backgroundSize;
        bg += ' ' + this.internal_config.backgroundRepeat;
        bg += ' ' + this.internal_config.backgroundOrigin;
      }

      return bg;
    },

  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
        let pageMask = document.getElementById('page-mask');
        if (this.internal_config.backDrop)
          pageMask.className = 'page-mask-active';
         else
          pageMask.classList.remove('page-mask-active');

      },
    },
  },
  mounted() {

    let device, childs, id, config;
    ({device, childs, id, config} = this.$props);

    if (typeof config.backgroundColor === 'undefined')
      config.backgroundColor = '#FFFFFF';

    this.internal_config = config;
    this.device = device;

    if (typeof childs === 'undefined') {
      childs = [];
      this.internal_config.childs = [];
    }

    if (typeof id !== 'undefined')
      this.id = id;


    let objIds = [];
    $('[id][element]').each(function() {
      var ids = $('[id="' + this.id + '"]');
      if (ids.length > 1 && ids[0] == this && parseInt(this.id))
        objIds.push(this.id);
    });

    if (objIds.includes(this.id)) {
      let newId = Date.now() + parseInt(Math.random() * 10000);
      this.id = newId;

      childs.forEach((el, index) => {
        try {
          childs[index].config.parent_id = newId;
        } catch (e) {
        }
      });

      this.$refs.elem.id = newId;
    }

    if (this.internal_config.animation)
      delete this.internal_config.animation;


    this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));

    // this.internal_config = window.mergeRecursive(this.props, this.$props.config);
    let internal_config = window.mergeRecursive(this.props, this.$props.config);
    this.internal_config = {...internal_config, ...this.internal_config};

    this.$root.$on('setConfigElement', (id, obj) => {
      if (this.id == id) {
        this.config = obj;
        this.internal_config = obj;
      }
    });
    this.$root.$on('removeMenu', () => {
      if (this.$el.querySelectorAll('[element]').length === 0)
        this.addMenu();

    });

    this.$root.$on('setChildsObj', (id) => {
      if (this.id == id) {

        this.$eventPointer.logChilds(this.id, this.elements);

        let childsHub = this.$eventHub.getChilds(this.id);

        this.config.childs = childsHub;
        this.internal_config.childs = childsHub;

        this.elements = {};
        this.$nextTick(() => {
          this.elements = childsHub.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
          this.componentKey += 1;

          this.$nextTick(() => {
            this.sendNewChilds();
            this.$root.$emit('activeSort');
            this.$refs.resourcesData.setValuesData(this);
          });
        });
      }
    });
    this.$root.$on('setChildsUndoRedo', (id, childs) => {
      if (this.id == id) {
        this.$eventHub.setChilds(this.id, childs);

        this.config.childs = childs;
        this.internal_config.childs = childs;

        this.elements = {};
        this.$nextTick(() => {
          this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
          this.componentKey += 1;
        });
      }
    });

    this.build();

    this.$refs.resourcesData.setValuesData(this);
  },
  methods: {
    changeOrderPanel(elem, idx) {

      let id = elem.$el.id,
        sibling = idx === 1 ? document.getElementById(id).nextSibling : document.getElementById(id).previousSibling;

      if (sibling === null)
        return true;


      this.$root.$emit('changeOrderElementsInside', this.id, id, sibling.id, idx);

    },
    addMenu() {

      if (typeof this.$eventHub.getElement(this.id) === 'undefined') {
        let vm = this;
        setTimeout(() => {
          vm.addMenu();
        }, 1000);
      } else
        this.$root.$emit('createBaseElement', 'PlaceMenuComponent', {}, this.id);

    },
    onResize(x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },

    animation() {
      return false;
    },

    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();
    },
    handler: function(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);

      e.stopPropagation();
      e.preventDefault();
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },
    style() {
      return `left:  ${this.internal_config.left};
                top: ${this.internal_config.top};
				        padding-top: ${this.internal_config.paddingTop};
                padding-left: ${this.internal_config.paddingLeft};
                padding-right: ${this.internal_config.paddingRight};
                padding-bottom: ${this.internal_config.paddingBottom};
                z-index: ${this.internal_config.backDrop ? 2 : this.internal_config.zIndex};
                width: ${this.internal_config.width};
                max-width: ${this.internal_config.maxWidth};
                margin: 0 auto;`;
    },
    setCallbackChangeDevice(values) {
      this.$emit('setCallbackChangeDevice', values);
    },
    build() {
      let vm = this;
      setTimeout(() => {
        if (vm.$el.querySelectorAll('[element]').length === 0)
          vm.addMenu();


      }, 3000);
    },
    sendNewChilds() {

      let vm = this;

      setTimeout(() => {
        // console.log(vm.elements);
        vm.$eventPointer.changePointerState(true);
        vm.$eventPointer.logChilds(vm.id, vm.elements);
        setTimeout(() => {
          vm.$eventPointer.changePointerState(true);
        }, 500);
      }, 1000);
    },
  },
};

</script>
<style lang="scss">
[element="GroupMenuComponent"] {
  .vdr {
    // padding: 5px !important;
  }

  &:hover {
    .vdr {
      outline: 1px dotted blue;
    }
  }
}
</style>
<style lang="scss" scoped>

.card-body {
  position: relative;
}

.sitebuilder-element-container {

  .vdr {
    height: unset !important;

  }
}

[data-device="desktop"] {
  .container-menu-group {
    display: flex;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/editor/apps/BigMenu/GroupMenu/GroupMenu.vue